import { render, staticRenderFns } from "./aresGPT.vue?vue&type=template&id=120802d9&scoped=true"
import script from "./aresGPT.vue?vue&type=script&lang=js"
export * from "./aresGPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120802d9",
  null
  
)

export default component.exports